export default "__VITE_ASSET__BBMR$HZ7__"